<ng-template #eyeOpen>
  <svg
    class="w-6 h-6 hover:text-blue-500 text-gray-800 dark:text-white"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      stroke="currentColor"
      stroke-width="2"
      d="M21 12c0 1.2-4.03 6-9 6s-9-4.8-9-6c0-1.2 4.03-6 9-6s9 4.8 9 6Z"
    />
    <path
      stroke="currentColor"
      stroke-width="2"
      d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
    />
  </svg>
</ng-template>
<ng-template #eyeSlash>
  <svg
    class="w-6 h-6 hover:text-blue-500 text-gray-800 dark:text-white"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M3.933 13.909A4.357 4.357 0 0 1 3 12c0-1 4-6 9-6m7.6 3.8A5.068 5.068 0 0 1 21 12c0 1-3 6-9 6-.314 0-.62-.014-.918-.04M5 19 19 5m-4 7a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
    />
  </svg>
</ng-template>
<ng-template #checkCircle>
  <svg
    class="w-4 h-4 text-gray-800 dark:text-white"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M8.5 11.5 11 14l4-4m6 2a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
    />
  </svg>
</ng-template>
<ng-template #checkFilledCircle>
  <svg
    class="w-4 h-4 text-green-600 dark:text-white"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      fill-rule="evenodd"
      d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm13.707-1.293a1 1 0 0 0-1.414-1.414L11 12.586l-1.793-1.793a1 1 0 0 0-1.414 1.414l2.5 2.5a1 1 0 0 0 1.414 0l4-4Z"
      clip-rule="evenodd"
    />
  </svg>
</ng-template>

<!-- Signup Section: Not Verification Mode (Normal Signup) -->
<section class="bg-gray-50 dark:bg-gray-900">
  <!-- Signup Container -->
  <div
    class="flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0"
  >
    <!-- Logo Section -->
    <a
      href="#"
      class="flex items-center mb-5 text-2xl font-semibold text-gray-900 dark:text-white"
    >
      @if (themeService.darkMode$ | async) {
        <img
          src="/assets/svg/LIQ_DDA_dark.svg"
          class="h-8"
          alt="Flowbite Logo"
        />
      } @else {
        <img
          src="/assets/svg/LIQ_DDA_white.svg"
          class="h-8"
          alt="Flowbite Logo"
        />
      }
    </a>
    <!-- Main Content -->
    <div
      class="w-full bg-white rounded-lg shadow dark:border md:mt-0 sm:max-w-md xl:p-0 dark:bg-gray-800 dark:border-gray-700"
    >
      <!-- Content Container -->
      <div class="p-6 space-y-4 md:space-y-6 sm:p-8">
        <!-- Signup Form Title -->
        <h1
          class="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-white"
        >
          Create an account
        </h1>
        @if (errorMessage) {
          <div
            class="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded"
            role="alert"
          >
            <h3 class="font-bold">
              Please correct the errors below and try again
            </h3>
            <p>{{ errorMessage }}</p>
          </div>
        }
        <!-- Form Content -->
        <form
          class="flex flex-col gap-2"
          [formGroup]="signupForm"
          (ngSubmit)="signUp()"
        >
          <!-- Form Container -->
          <div class="flex gap-4">
            <!-- First Name -->
            <div class="flex-1">
              <label
                for="firstName"
                class="block text-sm font-medium text-gray-900 dark:text-white"
                >First Name</label
              >
              <input
                type="text"
                id="firstName"
                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="First Name"
                formControlName="firstName"
                required
                [ngClass]="{
                  'border-red-600 focus:border-red-600 focus:ring-red-600':
                    getInputErrorMessage('firstName') !== null,

                  'border-gray-300 focus:border-primary-600 focus:ring-primary-600':
                    getInputErrorMessage('firstName') === null,
                }"
              />
              <div
                class="text-red-600 text-nowrap text-sm min-h-5 ps-1"
                [ngClass]="{
                  invisible: getInputErrorMessage('firstName') === null,
                }"
              >
                {{ getInputErrorMessage("firstName") }}
              </div>
            </div>
            <!-- Last Name -->
            <div class="flex-1">
              <label
                for="lastName"
                class="block text-sm font-medium text-gray-900 dark:text-white"
                >Last Name</label
              >
              <input
                type="text"
                id="lastName"
                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="Last Name"
                formControlName="lastName"
                required
                [ngClass]="{
                  'border-red-600 focus:border-red-600 focus:ring-red-600':
                    getInputErrorMessage('lastName') !== null,

                  'border-gray-300 focus:border-primary-600 focus:ring-primary-600':
                    getInputErrorMessage('lastName') === null,
                }"
              />
              <div
                class="text-red-600 text-nowrap text-sm min-h-5 ps-1"
                [ngClass]="{
                  invisible: getInputErrorMessage('lastName') === null,
                }"
              >
                {{ getInputErrorMessage("lastName") }}
              </div>
            </div>
          </div>
          <!-- Email -->
          <div>
            <label
              for="email"
              class="block text-sm font-medium text-gray-900 dark:text-white"
              >Email</label
            >
            <input
              type="email"
              name="email"
              id="email"
              class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              placeholder="name@email.com"
              formControlName="email"
              required
              [ngClass]="{
                'border-red-600 focus:border-red-600 focus:ring-red-600':
                  getInputErrorMessage('email') !== null,

                'border-gray-300 focus:border-primary-600 focus:ring-primary-600':
                  getInputErrorMessage('email') === null,
              }"
            />
            <div
              class="text-red-600 text-nowrap text-sm min-h-5 ps-1"
              [ngClass]="{
                invisible: getInputErrorMessage('email') === null,
              }"
            >
              {{ getInputErrorMessage("email") }}
            </div>
          </div>
          <!-- Password -->
          <div>
            <label
              for="password"
              class="block text-sm font-medium text-gray-900 dark:text-white"
              >Password</label
            >
            <div class="relative">
              <input
                [type]="showPassword ? 'text' : 'password'"
                name="password"
                id="password"
                placeholder="••••••••"
                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 pe-10 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                formControlName="password"
                required
                [ngClass]="{
                  'border-red-600 focus:border-red-600 focus:ring-red-600':
                    passwordControl?.invalid &&
                    (passwordControl?.dirty || passwordControl?.touched),

                  'border-gray-300 focus:border-primary-600 focus:ring-primary-600':
                    !(
                      passwordControl?.invalid &&
                      (passwordControl?.dirty || passwordControl?.touched)
                    ),
                }"
              />
              <button
                type="button"
                [title]="showPassword ? 'Hide password' : 'Show password'"
                class="absolute right-2 inset-y-0"
                (click)="showPassword = !showPassword"
              >
                <ng-container
                  [ngTemplateOutlet]="showPassword ? eyeOpen : eyeSlash"
                />
              </button>
            </div>
            <ul class="ps-1 mt-2">
              @for (criterion of passwordCriteria; track criterion.at(0)) {
                <li
                  *ngIf="criterion.at(0) !== undefined"
                  class="text-sm"
                  [ngClass]="{
                    'text-green-800':
                      signupForm.get('password')?.hasError(criterion[0]) ===
                        false && signupForm.get('password')?.value.length > 0,
                    'text-gray-500':
                      signupForm.get('password')?.hasError(criterion[0]) ===
                        true || signupForm.get('password')?.value.length === 0,
                  }"
                >
                  <div class="flex flex-row gap-2 items-center">
                    <ng-container
                      [ngTemplateOutlet]="
                        (
                          signupForm.get('password')?.hasError(criterion[0]) ===
                            false &&
                          signupForm.get('password')?.value.length > 0
                        ) ?
                          checkFilledCircle
                        : checkCircle
                      "
                    />
                    {{ criterion.at(1) }}
                  </div>
                </li>
              }
            </ul>
          </div>
          <!-- Confirmed Password -->
          <div>
            <label
              for="confirm-password"
              class="block text-sm font-medium text-gray-900 dark:text-white"
              >Confirm password</label
            >
            <div class="relative">
              <input
                [type]="showConfirmedPassword ? 'text' : 'password'"
                id="confirm-password"
                placeholder="••••••••"
                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 pr-10 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                formControlName="confirmedPassword"
                required
                [ngClass]="{
                  'border-red-600 focus:border-red-600 focus:ring-red-600':
                    getInputErrorMessage('confirmedPassword') !== null,

                  'border-gray-300 focus:border-primary-600 focus:ring-primary-600':
                    getInputErrorMessage('confirmedPassword') === null,
                }"
              />
              <button
                type="button"
                [title]="
                  showConfirmedPassword ? 'Hide password' : 'Show password'
                "
                class="absolute right-2 inset-y-0"
                (click)="showConfirmedPassword = !showConfirmedPassword"
              >
                <ng-container
                  [ngTemplateOutlet]="
                    showConfirmedPassword ? eyeOpen : eyeSlash
                  "
                />
              </button>
            </div>
            <div
              class="text-red-600 text-nowrap text-sm min-h-5 ps-1"
              [ngClass]="{
                invisible: getInputErrorMessage('confirmedPassword') === null,
              }"
            >
              {{ getInputErrorMessage("confirmedPassword") }}
            </div>
          </div>
          <!-- Phone Number (Optional) -->
          <div>
            <label
              for="email"
              class="block text-sm font-medium text-gray-900 dark:text-white"
              >Phone Number (Optional)</label
            >
            <input
              type="text"
              name="phone"
              id="phone"
              class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              formControlName="phone"
              [ngClass]="{
                'border-red-600 focus:border-red-600 focus:ring-red-600':
                  getInputErrorMessage('phone') !== null,

                'border-gray-300 focus:border-primary-600 focus:ring-primary-600':
                  getInputErrorMessage('phone') === null,
              }"
            />
            <div
              class="text-red-600 text-nowrap text-sm min-h-5 ps-1"
              [ngClass]="{
                invisible: getInputErrorMessage('phone') === null,
              }"
            >
              {{ getInputErrorMessage("phone") }}
            </div>
          </div>
          <!-- Invitation Code -->
          <div>
            <label
              for="email"
              class="block text-sm font-medium text-gray-900 dark:text-white"
              >Invitation Code</label
            >
            <input
              type="text"
              id="invitation_code"
              class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              placeholder="XXXX-XXXX-XXXX"
              formControlName="invitationCode"
              required
              [ngClass]="{
                'border-red-600 focus:border-red-600 focus:ring-red-600':
                  getInputErrorMessage('invitationCode') !== null,

                'border-gray-300 focus:border-primary-600 focus:ring-primary-600':
                  getInputErrorMessage('invitationCode') === null,
              }"
            />
            <div
              class="text-red-600 text-nowrap text-sm min-h-5 ps-1"
              [ngClass]="{
                invisible: getInputErrorMessage('invitationCode') === null,
              }"
            >
              {{ getInputErrorMessage("invitationCode") }}
            </div>
          </div>
          <!-- Accepting Terms and Conditions -->
          <!-- <div class="flex items-start">
            <div class="flex items-center h-5">
              <input
                id="terms"
                aria-describedby="terms"
                type="checkbox"
                class="w-4 h-4 border border-gray-300 rounded bg-gray-50 focus:ring-3 focus:ring-blue-300 dark:bg-gray-700 dark:border-gray-600 dark:focus:ring-blue-600 dark:ring-offset-gray-800"
                required=""
              />
            </div>
            <div class="ml-3 text-sm">
              <label
                for="terms"
                class="font-light text-gray-500 dark:text-gray-300"
                >I accept the
                <a
                  class="font-medium text-blue-600 hover:underline dark:text-blue-500"
                  href="#"
                  >Terms and Conditions</a
                ></label
              >
            </div>
          </div> -->
          <button
            type="submit"
            class="mt-4 w-full text-white bg-blue-600 hover:bg-blue-700 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
          >
            Create an account
          </button>
          <p class="text-sm font-light text-gray-500 dark:text-gray-400">
            Already have an account?
            <a
              (click)="directTo('login')"
              class="font-medium text-blue-600 hover:underline dark:text-blue-500 cursor-pointer"
              >Login here</a
            >
          </p>
        </form>
      </div>
    </div>
  </div>
</section>
